<style>
.align-center {
  text-align: center;
}

.valid {
  border: 1px solid rgb(40, 167, 69) !important;
}

.invalid {
  border: 1px solid rgb(220, 53, 69) !important;
}
</style>

<template>
  <div class="form-group">
    <div :class="hasIcon(icon)">
      <span v-if="iconDir === 'left'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
      <!-- <input :type="type" class="form-control align-center" :class="getClasses(size, valid)" :name="name" :id="id"
        :placeholder="placeholder" :isRequired="isRequired" :value="formattedValue" @input="updateInputValue" /> -->

      <input :type="type" class="form-control align-center" :class="validity" :name="name"
        :id="id" :placeholder="placeholder" :isRequired="isRequired" :value="formattedValue" @input="handleInput"
        maxlength="18" />
      <span v-if="iconDir === 'right'" class="input-group-text">
        <i :class="getIcon(icon)"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "argon-input",
  props: {
    size: {
      type: String,
      default: "default",
    },
    icon: String,
    iconDir: String,
    name: String,
    id: String,
    placeholder: String,
    type: String,
    isRequired: Boolean,
    modelValue: String,
  },
  data() {
    return {
      formattedValue: this.formatDocument(this.modelValue),
      validity: ''
    }
  },
  methods: {
    getClasses: (size) => {
      let sizeValue;

      sizeValue = size ? `form-control-${size}` : null;

      return `${sizeValue}`;
    },
    getIcon: (icon) => (icon ? icon : null),
    hasIcon: (icon) => (icon ? "input-group" : null),

    formatDocument(value) {
      // Remove caracteres não numéricos
      let numeroLimpo = value.replace(/\D/g, '');
      numeroLimpo = numeroLimpo.substring(0, 14);

      // Verifica se é CPF ou CNPJ
      if (numeroLimpo.length <= 11) {
        // Formata como CPF
        if (numeroLimpo.length >= 4) {
          numeroLimpo = numeroLimpo.substring(0, 3) + '.' + numeroLimpo.substring(3);
        }
        if (numeroLimpo.length >= 7) {
          numeroLimpo = numeroLimpo.substring(0, 7) + '.' + numeroLimpo.substring(7);
        }
        if (numeroLimpo.length >= 11) {
          numeroLimpo = numeroLimpo.substring(0, 11) + '-' + numeroLimpo.substring(11);
        }
      } else {
        // Formata como CNPJ
        if (numeroLimpo.length >= 2) {
          numeroLimpo = numeroLimpo.substring(0, 2) + '.' + numeroLimpo.substring(2);
        }
        if (numeroLimpo.length >= 6) {
          numeroLimpo = numeroLimpo.substring(0, 6) + '.' + numeroLimpo.substring(6);
        }
        if (numeroLimpo.length >= 10) {
          numeroLimpo = numeroLimpo.substring(0, 10) + '/' + numeroLimpo.substring(10);
        }
        if (numeroLimpo.length >= 15) {
          numeroLimpo = numeroLimpo.substring(0, 15) + '-' + numeroLimpo.substring(15);
        }
      }

      return numeroLimpo;
    },

    handleInput(event) {
      this.formattedValue = this.formatDocument(event.target.value);
      this.$emit('update:modelValue', this.formattedValue);
      this.validity = this.validateDocument(this.formattedValue);
      this.$emit('update:validity', this.validity);
    },

    validateCPF(number) {
      var sum;
      var rest;
      var i;
      sum = 0;
      if (number.length !== 11 || !Array.from(number).filter(e => e !== number[0]).length) {
        return false
      }

      for (i = 1; i <= 9; i++) sum += parseInt(number.substring(i - 1, i), 10) * (11 - i);
      rest = (sum * 10) % 11;

      if ((rest === 10) || (rest === 11)) rest = 0;
      if (rest !== parseInt(number.substring(9, 10), 10)) return false;

      sum = 0;
      for (i = 1; i <= 10; i++) sum += parseInt(number.substring(i - 1, i), 10) * (12 - i);
      rest = (sum * 10) % 11;

      if ((rest === 10) || (rest === 11)) rest = 0;
      if (rest !== parseInt(number.substring(10, 11), 10)) return false;
      return true;
    },

    validateCNPJ(value) {
      if (!value) return false

      // Aceita receber o valor como string, número ou array com todos os dígitos
      const validTypes =
        typeof value === 'string' || Number.isInteger(value) || Array.isArray(value)

      // Elimina valor em formato inválido
      if (!validTypes) return false

      // Guarda um array com todos os dígitos do valor
      const match = value.toString().match(/\d/g)
      const numbers = Array.isArray(match) ? match.map(Number) : []

      // Valida a quantidade de dígitos
      if (numbers.length !== 14) return false

      // Elimina inválidos com todos os dígitos iguais
      const items = [...new Set(numbers)]
      if (items.length === 1) return false

      // Cálculo validador
      const calc = (x) => {
        const slice = numbers.slice(0, x)
        let factor = x - 7
        let sum = 0

        for (let i = x; i >= 1; i--) {
          const n = slice[x - i]
          sum += n * factor--
          if (factor < 2) factor = 9
        }

        const result = 11 - (sum % 11)

        return result > 9 ? 0 : result
      }

      // Separa os 2 últimos dígitos de verificadores
      const digits = numbers.slice(12)

      // Valida 1o. dígito verificador
      const digit0 = calc(12)
      if (digit0 !== digits[0]) return false

      // Valida 2o. dígito verificador
      const digit1 = calc(13)
      return digit1 === digits[1]
    },

    validateDocument(document) {
      let valid

      document = document.replace(/\D/g, '');

      if (document.length === 11) {
        valid = this.validateCPF(document)
      }
      else if (document.length === 14) {
        valid = this.validateCNPJ(document)
      }
      else {
        return 'filling'
      }

      if (valid) {
        return 'valid'
      }
      else {
        return 'invalid'
      }
    }
  },
};
</script>
